import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormWidgetPersonModule } from '@modules/bcm/@work-flows/@form-widgets/person/form-widget-person.module';
import { FormWidgetCompanyModule } from '@modules/bcm/@work-flows/@form-widgets/company/form-widget-company.module';
import { FormWidgetInvoiceModule } from '@bcm-work-flows/@form-widgets/invoice/form-widget-invoice.module';
import { FormWidgetSubscriptionPeriodModule } from '@bcm-work-flows/@form-widgets/subscription-period/form-widget-subscription-period.module';
import { TranslationModule } from '@core/translation/translation.module';
import { WinterStorageAssignmentBillingPanelComponent } from './winter-storage-assignment-billing-panel.component';

@NgModule({
    declarations: [WinterStorageAssignmentBillingPanelComponent],
    imports: [
        FuseSharedModule,
        SharedModule,
        MatDividerModule,
        MatRadioModule,
        MatCheckboxModule,
        FormWidgetPersonModule,
        FormWidgetCompanyModule,
        FormWidgetInvoiceModule,
        FormWidgetSubscriptionPeriodModule,
        TranslationModule,
    ],
    exports: [WinterStorageAssignmentBillingPanelComponent],
})
export class WinterStorageAssignmentBillingPanelModule {
}
